document.addEventListener("DOMContentLoaded", () => {

  const heroText = document.querySelectorAll(".hero-text");
  const btnItems = document.querySelectorAll("#btn");

  gsap.to(heroText, {
    opacity: 1,
    duration: 0.8,
    delay: 1,
    stagger: 0.1
  });

  gsap.to(btnItems, {
    opacity: 1,
    y: -30,
    duration: 0.8,
    delay: 1,
    stagger: 0.1
  });

});